import api from '../../http/api.js'
import { getField, updateField } from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        show: false,
        insurable_id: null,
        expire_date: null,
        insured_details: {            
            first_name: null,
            second_name: null,
            address: null,
            city: null,
            country: null,
            phone_prefix: null,
            phone_number: null,
            email: null,
        },
        //event
        event_date: null,
        event_place: null,            
        event_description: null,
        coverage: '',
        claim: '',
        //claim
        details: {     
            bank_identifier: null, // iban or account number
            bank_swift_bic: null,
            bank_different_holder: "No",
            bank_account_holder: null
        },
    }
}

export const openClaim = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        initialize({commit}){
            return new Promise((resolve, reject) => {
                // se nuovo sinistro, carico solo i dati dell'anagrafica
                api.get('/v1/me')
                    .then((response) => {
                        //console.log(response.data.data.in_coverage);
                        // out of coverage
                        commit('setInsured', response.data.data)
                        // rinomino name e surname, in first_name, second_name
                        const { name, surname, ...rest } = response.data.data.infos;
                        commit('setInsuredDetails', { first_name: name, second_name: surname, ...rest });
                        
                        resolve(response);
                    }, (err) => {
                        //console.log(error);
                        reject(err)
                    });
            });
            
        },
        openClaim({ getters }){
            return new Promise((resolve, reject) => {
                api.post('/v1/insurancepolicies/1/claims', getters.prepareClaim)
                    .then((resp) => {
                        //commit('accept_privacy', privacy);
                        resolve(resp);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        resetState({commit}){
            commit('resetState');
        }
    },
    getters: {

        getField,
        getExpireDate(state){
            return state.expire_date;
        },
        policyNumber(state, getters, rootState){
            return rootState.userInfo.policyNumber;
        },
        prepareClaim(state){

            // prepare claim payload
            const claim = {
                insurable_id: state.insurable_id,
                event_date: state.event_date,
                event_place: state.event_place,
                event_description: state.event_description,
                coverage: state.coverage,
                claim: state.claim,
                insured_details: state.insured_details,
                details: state.details
            }
            return claim
        }
    },
    mutations: {
        updateField,
        setInsured(state, data){
            state.insurable_id = data.insurable_id;
            state.expire_date = data.expire_date;
        },
        setInsuredDetails(state, data){
            state.insured_details = data
            state.show = true
        },
        resetState(state){
            Object.assign(state, getDefaultState())
        },
    },
};